/* CNobre Store Portugal — product description normalization for Luxury */
(function(){
  function removeLegacyInlineStyles(scope){
    if(!scope) return;
    scope.querySelectorAll('[style]').forEach(function(el){
      el.removeAttribute('style');
    });
  }

  function cleanQuestionBullets(scope){
    if(!scope) return;
    scope.querySelectorAll('li').forEach(function(li){
      if(/^\s*\?\s*/.test(li.textContent || '')){
        var html = li.innerHTML || '';
        li.innerHTML = html.replace(/^\s*\?\s*/, '✓ ');
      }
    });
  }

  function normalizeImages(root, scope){
    if(!root || !scope) return;
    var canonical = root.getAttribute('data-cn-card-src') || '';
    var alt = root.getAttribute('data-cn-card-alt') || '';
    var src480  = root.getAttribute('data-cn-card-src-480') || '';
    var src700  = root.getAttribute('data-cn-card-src-700') || '';
    var src900  = root.getAttribute('data-cn-card-src-900') || '';
    var src1200 = root.getAttribute('data-cn-card-src-1200') || '';
    var images = Array.prototype.slice.call(scope.querySelectorAll('img'));
    var primary = scope.querySelector('img[data-cn-card-image="1"]') || images[0] || null;

    images.forEach(function(img){
      var src = img.getAttribute('src') || '';
      var external = /^https?:\/\//i.test(src) && !/cdn\.shopify\.com|shopifycdn/i.test(src);
      if(external && img !== primary){
        img.remove();
      }
    });

    if(primary){
      var src = primary.getAttribute('src') || '';
      var external = /^https?:\/\//i.test(src) && !/cdn\.shopify\.com|shopifycdn/i.test(src);
      if((external || !src) && canonical) primary.setAttribute('src',canonical);
      primary.setAttribute('data-cn-card-image','1');
      if(alt) primary.setAttribute('alt',alt);
      primary.setAttribute('loading','lazy');
      primary.setAttribute('decoding','async');
      var parts=[];
      if(src480) parts.push(src480+' 480w');
      if(src700) parts.push(src700+' 700w');
      if(src900) parts.push(src900+' 900w');
      if(src1200) parts.push(src1200+' 1200w');
      if(parts.length){
        primary.setAttribute('srcset',parts.join(', '));
        primary.setAttribute('sizes','(max-width: 749px) 92vw, 460px');
      }
    }
  }

  function buildLegacyCard(root){
    if(!root || root.querySelector('.cn-product-card')) return root.querySelector('.cn-product-card');

    var faq = root.querySelector('.cnobre-faq');
    var nodes=[];
    Array.prototype.slice.call(root.childNodes).forEach(function(node){
      if(faq && (node===faq || (node.nodeType===1 && node.contains && node.contains(faq)))) return;
      if(node.nodeType===1 && node.tagName==='SCRIPT') return;
      if(faq && node.compareDocumentPosition && (node.compareDocumentPosition(faq) & Node.DOCUMENT_POSITION_FOLLOWING)===0) return;
      nodes.push(node);
    });
    if(!nodes.length) return null;

    if(nodes.length===1 && nodes[0].nodeType===1 && /^(DIV|SECTION|ARTICLE)$/.test(nodes[0].tagName)){
      nodes[0].classList.add('cn-product-card','cn-product-card--legacy');
      return nodes[0];
    }

    var card=document.createElement('div');
    card.className='cn-product-card cn-product-card--legacy';
    root.insertBefore(card,nodes[0]);
    nodes.forEach(function(node){card.appendChild(node);});
    return card;
  }

  function stripHighlightChecks(list){
    if(!list) return;
    var items = (list.tagName === 'UL' || list.tagName === 'OL')
      ? Array.prototype.slice.call(list.children || [])
      : Array.prototype.slice.call(list.querySelectorAll('li'));
    list.classList.toggle('product-highlights--two', items.length === 2);
    list.classList.toggle('product-highlights--four', items.length === 4);
    list.classList.toggle('product-highlights--five', items.length === 5);
    items.forEach(function(li){
      if(!li || li.tagName !== 'LI') return;
      var html = li.innerHTML || '';
      li.innerHTML = html.replace(/^\s*(?:(?:[\u{1F300}-\u{1FAFF}\u{2600}-\u{27BF}])(?:\uFE0F|\uFE0E)?(?:\u200D(?:[\u{1F300}-\u{1FAFF}\u{2600}-\u{27BF}])(?:\uFE0F|\uFE0E)?)*)+\s*/u,'');
    });
  }

  function buildLuxurySummary(root){
    if(!root || root.querySelector('.cn-product-summary')) return;
    var children = Array.prototype.slice.call(root.children || []);
    var intro = children.find(function(el){ return el.classList && el.classList.contains('cn-one-liner'); }) || null;
    var highlights = children.find(function(el){ return el.classList && el.classList.contains('product-highlights'); }) || null;
    if(!intro && !highlights) return;

    var first = intro || highlights;
    var summary = document.createElement('div');
    summary.className = 'cn-product-summary';
    root.insertBefore(summary, first);

    if(intro) summary.appendChild(intro);
    if(highlights){
      stripHighlightChecks(highlights);
      summary.appendChild(highlights);
    }
  }

  function normalizeRoot(root){
    if(!root) return;
    buildLuxurySummary(root);
    var card=root.querySelector('.cn-product-card') || buildLegacyCard(root);
    if(!card) return;

    removeLegacyInlineStyles(card);
    cleanQuestionBullets(card);
    normalizeImages(root,card);

    card.querySelectorAll('font').forEach(function(el){
      var span=document.createElement('span');
      while(el.firstChild) span.appendChild(el.firstChild);
      el.replaceWith(span);
    });
  }

  function run(){
    document.querySelectorAll('[data-cn-desc-wrap="1"]').forEach(normalizeRoot);
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',run);
  } else {
    run();
  }
  document.addEventListener('shopify:section:load',run);

  /* CNOBRE_PDP_RETRY_300926: translations/sections can hydrate after initial DOM ready */
  window.addEventListener('pageshow',run);
  window.setTimeout(run,150);
  window.setTimeout(run,700);
  window.setTimeout(run,1600);

  if('MutationObserver' in window){
    var cnObserver=new MutationObserver(function(mutations){
      var relevant=mutations.some(function(m){
        if(!m.addedNodes || !m.addedNodes.length) return false;
        return Array.prototype.some.call(m.addedNodes,function(node){
          return node && node.nodeType===1 && (
            node.matches && node.matches('[data-cn-desc-wrap="1"], .cn-one-liner, .product-highlights') ||
            node.querySelector && node.querySelector('[data-cn-desc-wrap="1"], .cn-one-liner, .product-highlights')
          );
        });
      });
      if(relevant) window.setTimeout(run,0);
    });
    cnObserver.observe(document.documentElement,{childList:true,subtree:true});
  }
})();